import { WaitlistForm } from "@/components/WaitlistForm";
import type { Audience } from "@/content";

/**
 * Closing CTA — audience-neutral copy so it works for printers and studios
 * alike, but receives the active `audience` so the waitlist signup records
 * which persona the visitor picked.
 */
export function FinalCta({ audience }: { audience: Audience }) {
  return (
    <section id="waitlist" className="relative overflow-hidden bg-[oklch(17%_0_0)] py-24 sm:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(55% 55% at 50% 0%, color-mix(in oklch, var(--accent) 38%, transparent) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-6">
        <p className="text-sm font-semibold uppercase tracking-wider text-[color-mix(in_oklch,var(--accent)_65%,white)]">
          Lista de lanzamiento
        </p>
        <h2 className="mt-3 text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Pronto abrimos. Sumate para ser de los primeros.
        </h2>
        <p className="mt-4 text-lg text-white/70">
          Todavía no tenemos fecha cerrada — estamos terminando de construir Ciam con un grupo
          chico de imprentas y estudios que nos ayudan a pensar bien cada parte. Cuando abramos,
          los primeros en saber son los que están en esta lista.
        </p>

        <div className="mx-auto mt-8 max-w-md text-left">
          <WaitlistForm source="final-cta" audience={audience} size="lg" />
          <p className="mt-3 text-center text-sm text-white/55">
            Un solo correo cuando haya novedades concretas. Sin spam.
          </p>
        </div>
      </div>
    </section>
  );
}
